
import { NotificationManager } from 'react-notifications';

import apiURL from'./apiURL';
import cleanDeep from "clean-deep"

const Types = {
  WORKLOCATION_BALANCE_REPORT_MODAL: "WORKLOCATION_BALANCE_REPORT_MODAL",
  WORKLOCATION_GENERATING_BALANCE_REPORT: "WORKLOCATION_GENERATING_BALANCE_REPORT",
  WORKLOCATION_OPEN_MODAL: "WORKLOCATION_OPEN_MODAL",
  WORKLOCATION_SHOW_COMMENTS: "WORKLOCATION_SHOW_COMMENTS",
  WORKLOCATION_SHOW_ATTACHMENTS: "WORKLOCATION_SHOW_ATTACHMENTS",
  WORKLOCATION_SHOW_CANCEL_WORKLOCATION: "WORKLOCATION_SHOW_CANCEL_WORKLOCATION",
  WORKLOCATION_BREAKDOWN: "WORKLOCATION_BREAKDOWN",
  WORKLOCATION_BREAKDOWN_STATUS: "WORKLOCATION_BREAKDOWN_STATUS",
  WORKLOCATION_SAVING: "WORKLOCATION_SAVING",
  WORKLOCATION_SAVE_CURRENT: "WORKLOCATION_SAVE_CURRENT",
  WORKLOCATION_ATTACHMENT_DOWNLOADING: "WORKLOCATION_ATTACHMENT_DOWNLOADING",
  WORKLOCATION_ATTACHMENT_DOWNLOADED: "WORKLOCATION_ATTACHMENT_DOWNLOADED",
  WORKLOCATION_UPDATE_BALANCES: "WORKLOCATION_UPDATE_BALANCES",
  WORKLOCATION_UPDATING_BALANCES: "WORKLOCATION_UPDATING_BALANCES",
  WORKLOCATION_UPDATING: "WORKLOCATION_UPDATING",
  WORKLOCATION_UPDATE: "WORKLOCATION_UPDATE",
  WORKLOCATION_UPDATING_MODAL: "WORKLOCATION_UPDATING_MODAL",
  WORKLOCATION_UPDATE_MODAL: "WORKLOCATION_UPDATE_MODAL",
  WORKLOCATION_UPDATING_TIMELINE: 'WORKLOCATION_UPDATING_TIMELINE',
  WORKLOCATION_UPDATE_TIMELINE: 'WORKLOCATION_UPDATE_TIMELINE',
  WORKLOCATION_TYPES_UPDATING: "WORKLOCATION_TYPES_UPDATING",
  WORKLOCATION_TYPES_UPDATE: "WORKLOCATION_TYPES_UPDATE",
  WORKLOCATION_TYPES_PERMISSIONS: "WORKLOCATION_TYPES_PERMISSIONS",
  WORKLOCATION_LOCK_DATE: "WORKLOCATION_LOCK_DATE",
  WORKLOCATION_FUTURE_LOCK_DATE: "WORKLOCATION_FUTURE_LOCK_DATE",
  WORKLOCATION_SETTINGS_SET: "WORKLOCATION_SETTINGS_SET",
  WORKLOCATION_SETTINGS_UPDATING: "WORKLOCATION_SETTINGS_UPDATING",
  WORKLOCATION_SETTINGS_UPDATE: "WORKLOCATION_SETTINGS_UPDATE",
  WORKLOCATION_PERMISSIONS_UPDATING: "WORKLOCATION_PERMISSIONS_UPDATING",
  WORKLOCATION_PERMISSIONS_UPDATE: "WORKLOCATION_PERMISSIONS_UPDATE",
  WORKLOCATION_FILE_UPLOADING: "WORKLOCATION_FILE_UPLOADING",
  WORKLOCATION_FILE_UPLOADED: "WORKLOCATION_FILE_UPLOADED",
  WORKLOCATION_TAB: "WORKLOCATION_TAB",
  WORKLOCATION_DETAILED_REPORT_DOWNLOADING: "WORKLOCATION_DETAILED_REPORT_DOWNLOADING",
  WORKLOCATION_SETTINGS_SAVING: "WORKLOCATION_SETTINGS_SAVING",
  WORKLOCATION_CARRYOVER_STATUS: "WORKLOCATION_CARRYOVER_STATUS",
  WORKLOCATION_TYPES_ADD: "WORKLOCATION_TYPES_ADD",
  WORKLOCATION_TYPES_NAME: "WORKLOCATION_TYPES_NAME",
  WORKLOCATION_TYPE_DELETE: "WORKLOCATION_TYPE_DELETE",
  WORKLOCATION_PIN_MODAL: "WORKLOCATION_PIN_MODAL",
  WORKLOCATION_TYPES_PIN: "WORKLOCATION_TYPES_PIN",
};


const workLocationBreakdownStatus = processing => ({
  type: Types.WORKLOCATION_BREAKDOWN_STATUS,
  processing,
});

const workLocationBreakdown = payload => ({
  type: Types.WORKLOCATION_BREAKDOWN,
  payload
});

const workLocationGetBreakdown = (id) => {
  return (dispatch, getState) => {

    const state = getState()
    
    dispatch(workLocationBreakdownStatus(true))

    fetch(apiURL + `/settings/workLocation/${id}/breakdown` , {
      credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
    }).then(response => response.json())
      .then(response => {
        dispatch(workLocationBreakdown(response))
      })
  }
}

const workLocationCarryoverStatus = processing => ({
  type: Types.WORKLOCATION_CARRYOVER_STATUS,
  processing,
});

const processWorkLocationCarryover = (method, maxHours) => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(workLocationCarryoverStatus(true));

    fetch(apiURL + `/settings/workLocation/carryover`, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({ method, maxHours }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        dispatch(workLocationCarryoverStatus(false));
      });
  };
};

// actions

const workLocationTab = (tab) => ({
  type: Types.WORKLOCATION_TAB,
  tab,
});

const workLocationUpdating = ({ from, to }) => ({
  type: Types.WORKLOCATION_UPDATING,
  from,
  to,
});

const workLocationUpdatingModal = ({ from, to }) => ({
  type: Types.WORKLOCATION_UPDATING_MODAL,
  from,
  to,
});

const workLocationUpdatingTimeline = ({ from, to }) => ({
  type: Types.WORKLOCATION_UPDATING_TIMELINE,
  from,
  to,
});

const workLocationUpdate = ({ workLocation, from, to }) => ({
  type: Types.WORKLOCATION_UPDATE,
  workLocation,
  from,
  to,
});

const workLocationUpdateModal = ({ workLocation, from, to }) => ({
  type: Types.WORKLOCATION_UPDATE_MODAL,
  workLocation,
  from,
  to,
});

const workLocationUpdateTimeline = ({ workLocation, from, to }) => ({
  type: Types.WORKLOCATION_UPDATE_TIMELINE,
  workLocation,
  from,
  to,
});

const workLocationGet = (options, forModal, forTimeline) => {
  // console.log('Hola Jonathan', forModal, forTimeline);
  return (dispatch, getState) => {
    if (forModal) {
      dispatch(workLocationUpdatingModal(options));
    } else if (forTimeline) {
      dispatch(workLocationUpdatingTimeline(options));
    } else {
      dispatch(workLocationUpdating(options));
    }

    // options should be cleaned only real values included
    const qs = new URLSearchParams(options).toString();

    fetch(apiURL + `/settings/workLocation?${qs}`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        // setWorkLocation(response.workLocation)
        // setWorkLocationLoading(false)

        if (forModal) {
          dispatch(workLocationUpdateModal({ workLocation: response.workLocation, ...options }));
        } else if (forTimeline) {
          dispatch(workLocationUpdateTimeline({ workLocation: response.workLocation, ...options }));
        } else {
          dispatch(workLocationUpdate({ workLocation: response.workLocation, ...options }));
        }
      });
  };
};


const detailedReportDownloading = (status) => ({
  type: Types.WORKLOCATION_DETAILED_REPORT_DOWNLOADING,
  status,
});

const downloadDetailedReport = (options) => {
  return (dispatch, getState) => {

    dispatch(detailedReportDownloading(true))

    // options should be cleaned only real values included
    const qs = new URLSearchParams(options).toString();

    fetch(apiURL + `/settings/workLocation/detailedReport?${qs}` , {
      credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
    }).then(response => response.json())
      .then(response => {


        if (response && response.signedURL){
          const popup = window.open(response.signedURL);
          if (!popup || popup.closed || typeof popup.closed=='undefined'){
            //Worked For IE and Firefox
            alert("Popup Blocker is enabled! Please add this site to your exception list.");
          }
        } else {
          // $.notify('There was a problem creating your report.', {type:'error'});
        }

        dispatch(detailedReportDownloading(false))
      })
  }
}

const setWorkLocationSetting = ({option, value}) => ({
  type: Types.WORKLOCATION_SETTINGS_SET,
  option,
  value,
});

const workLocationSettingsUpdating = () => ({
  type: Types.WORKLOCATION_SETTINGS_UPDATING,
});
const workLocationSettingsSaving= (saving) => ({
  type: Types.WORKLOCATION_SETTINGS_SAVING,
  saving
});

const deleteWorkLocation = (id) => ({
  type: Types.WORKLOCATION_TYPE_DELETE,
  id
});

const workLocationSettingsUpdate = (workLocationSettings) => ({
  type: Types.WORKLOCATION_SETTINGS_UPDATE,
  workLocationSettings,
});

const getWorkLocationSettings = () => {
  return (dispatch, getState) => {
    dispatch(workLocationSettingsUpdating());

    fetch(apiURL + `/settings/workLocation/settings`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        // setWorkLocation(response.workLocation)
        // setWorkLocationLoading(false)

        dispatch(workLocationSettingsUpdate(response));
      });
  };
};

const workLocationSettingsUpdated = (workLocationTypes) => ({
  type: Types.WORKLOCATION_PERMISSIONS_UPDATE,
  workLocationTypes,
});

const saveWorkLocationSettings = () => {
  return async (dispatch, getState) => {
    const state = getState();

    const workLocationOptions = state.workLocation && typeof(state.workLocation.workLocationOptions) == "object" && state.workLocation.workLocationOptions || {}

    dispatch(workLocationSettingsSaving(true));

    await fetch(apiURL + `/settings/workLocation/settings`, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(cleanDeep({
        types: state.workLocation.types?.map(item => ({...item, newEntry: undefined})),
        ...workLocationOptions
      })),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        // setWorkLocation(response.workLocation)
        // setWorkLocationLoading(false)

        dispatch(workLocationSettingsSaving());
        NotificationManager.success('Work Locations saved successfully!', 'Saving Work Locations')
        dispatch(getWorkLocationSettings())
      })
      .catch(error => {
        console.error(error)
        NotificationManager.error('Error saving Work Locations!', 'Saving Work Locations')
      })
  };
};

const addWorkLocation = () => ({
  type: Types.WORKLOCATION_TYPES_ADD,
});

const setWorkLocationName = (workLocationType, name) => ({
  type: Types.WORKLOCATION_TYPES_NAME,
  workLocationType,
  name,
});

const toggleWorkLocationSettings = (workLocationType, permission) => ({
  type: Types.WORKLOCATION_TYPES_PERMISSIONS,
  workLocationType,
  permission,
});

const setWorkLocationLockDate = (date) => ({
  type: Types.WORKLOCATION_LOCK_DATE,
  date,
});

const setWorkLocationFutureLockDate = (date) => ({
  type: Types.WORKLOCATION_FUTURE_LOCK_DATE,
  date,
});

// actions
const showWorkLocationBalanceReportModal = (status) => ({
  type: Types.WORKLOCATION_BALANCE_REPORT_MODAL,
  status: status,
});

const setWorkLocationPinModal = (workLocation, status) => ({
  type: Types.WORKLOCATION_PIN_MODAL,
  status: status,
  workLocation,
})

const setOpenModal = (status, workLocation) => ({
  type: Types.WORKLOCATION_OPEN_MODAL,
  status: status,
  workLocation,
});

const showCancelWorkLocation = (workLocation, status) => ({
  type: Types.WORKLOCATION_SHOW_CANCEL_WORKLOCATION,
  status,
  workLocation,
});

// actions
const showComments = (workLocation) => ({
  type: Types.WORKLOCATION_SHOW_COMMENTS,
  workLocation,
});

// actions
const showAttachments = (workLocation) => ({
  type: Types.WORKLOCATION_SHOW_ATTACHMENTS,
  workLocation,
});

const workLocationSetSaving = (id) => ({
  type: Types.WORKLOCATION_SAVING,
  id,
});

const workLocationUpdateSaveStatus = (response, workLocation) => ({
  type: Types.WORKLOCATION_SAVE_CURRENT,
  payload: response,
  workLocation,
});

const saveWorkLocation = (workLocation) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(workLocationSetSaving((workLocation && workLocation.id) || true));

    const attachments =
      state.mode == 'manager'
        ? state.team.filesUploaded
        : state.my.filesUploaded;

    if (attachments && attachments.length > 0) {
      workLocation.attachments = attachments;
    }

    const path = '/settings/workLocation';

    fetch(apiURL + path, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(workLocation),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('entity data', data);
        dispatch(workLocationUpdateSaveStatus(data, workLocation));
      });
  };
};


const getStepFunctionState = ({ arn, name }) => {
  return (dispatch, getState) => {
    const state = getState();

    const path = `/pdf/report-status/${arn}`;

    fetch(apiURL + path, {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('entity data', data);

        const finished = data.data.status != 'RUNNING';

        if (finished) {
          if (data.data.status == 'SUCCEEDED') {
            if (name == 'workLocationBalanceReport') {
              // $.notify('Your report is ready', { type: 'success' });

              const output = JSON.parse(data.data.output);

              let popup;
              popup = window.open(output.signedURL);
              popup = window.open(output.signedCsvURL);
              if (
                !popup ||
                popup.closed ||
                typeof popup.closed == 'undefined'
              ) {
                //Worked For IE and Firefox
                alert(
                  'Popup Blocker is enabled! Please add this site to your exception list.'
                );
              }

            }
          } else {
            // $.notify('There was a problem creating your report.', {
            //   type: 'error',
            // });
          }
        } else {
          setTimeout(() => {
            dispatch(getStepFunctionState({ arn, name }));
          }, 1000);
        }
      });
  };
};

const gettingAttachment = (key) => ({
  type: Types.WORKLOCATION_ATTACHMENT_DOWNLOADING,
  key,
});

const attachmentDownloaded = (payload, key) => ({
  type: Types.WORKLOCATION_ATTACHMENT_DOWNLOADED,
  key,
  payload,
});

const getAttachment = (attachment) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(gettingAttachment(attachment.key));

    const path = `/settings/getAttachment`;

    fetch(apiURL + path, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(attachment),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('entity data', data);
        dispatch(attachmentDownloaded(data, attachment.key));
      });
  };
};

const setFileUploading = (file) => ({
  type: Types.WORKLOCATION_FILE_UPLOADING,
  file,
});

const setFileUploaded = (file, key) => ({
  type: Types.WORKLOCATION_FILE_UPLOADED,
  file,
  key,
});

const uploadFile = ({ file, agreement }) => {
  return (dispatch, getState) => {
    const state = getState();

    const path = '/settings/upload';

    // NotificationManager.success('Your File is being uploaded','Info')
    dispatch(setFileUploading(file.name));

    fetch(apiURL + path, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({
        name: file.name,
        type: file.type,
        agreement,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('getImportStatus', data);

        const fileKey = data.key;

        // step 1 upload to AWS
        fetch(data.url, {
          credentials: 'include',
          method: 'PUT',
          body: file,
          headers: {
            Accept: 'application/json',
            'Content-Type': file.type,
          },
        }).then((data) => {
          dispatch(setFileUploaded(file.name, fileKey));
        });
      });
  };
};

const setWorkLocationPin = (workLocationType, pos) => ({
  type: Types.WORKLOCATION_TYPES_PIN,
  workLocationType,
  pos
});

const Actions = {
  workLocationGet,
  toggleWorkLocationSettings,
  setWorkLocationLockDate,
  setWorkLocationFutureLockDate,
  saveWorkLocationSettings,
  getWorkLocationSettings,
  setOpenModal,
  saveWorkLocation,
  showComments,
  showAttachments,
  showCancelWorkLocation,
  getAttachment,
  uploadFile,
  workLocationTab,
  workLocationGetBreakdown,
  downloadDetailedReport,
  setWorkLocationSetting,
  addWorkLocation,
  setWorkLocationName,
  deleteWorkLocation,
  setWorkLocationPinModal,
  setWorkLocationPin
}

// exports = {
//   Types,
//   Actions
// }

export { Types, Actions };

// exports.Types = Types
// exports.Actions = Actions
